import { PropTypes } from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';

import ContactInfoFieldset from '#client/components/ContactInfoFieldset';

function ContactInfoFields({ fieldsConfig }) {
  return (
    <Stack spacing={1.5}>
      <Heading component="h3" size="md" weight="medium">
        <FormattedMessage id="shopping.page.checkout.business.accountOwner" />
      </Heading>
      <ContactInfoFieldset fieldsConfig={fieldsConfig} />
    </Stack>
  );
}

ContactInfoFields.propTypes = {
  fieldsConfig: PropTypes.object
};

export default ContactInfoFields;
